export const ACCOUNTS_BASE_URL = 'https://demo.apty.io';
export const  EXTERNAL_API_ACCESS_KEY = 'c66a4116-dbd0-4c6c-90a7-f7dd30c07496';
export const CREATE_FREE_TRIAL_PATH = 'provision/v1/freeTrialTenant';
export const FREE_TRIAL_URL_KEY = 'free_trial_url';

export const getFreeTrialUrl = () => {
  const storedUrl = localStorage.getItem(FREE_TRIAL_URL_KEY);
  return storedUrl ? `${storedUrl}/accounts` : `${ACCOUNTS_BASE_URL}/accounts`;
};
